import { jsPDF } from 'jspdf';
import converter from 'number-to-words';
import logo from '../../../icons/Cet_emblem.jpg';

const generateFullReliefVoucherPDF = (inmateData, receiptOrVoucherNo) => {
  try {
    // Initialize PDF
    const doc = new jsPDF();

    // Calculate the settlement amount
    const advanceAmount = inmateData.advance_amount || 0;
    const usedAmount = inmateData.used_amount || 0;
    const balanceAmount = advanceAmount - usedAmount;
    const isRefund = balanceAmount > 0;

    // Function to generate single voucher copy
    const generateVoucherCopy = (startY, type) => {
      try {
        // Header
        doc.addFont('times', 'Times', 'normal');
        doc.setFont('Times');

        // Title section
        doc.addImage(logo, 'PNG', 20, startY + 2, 25, 25);

        doc.setFontSize(14);
        doc.text("HOSTEL OFFICE - COLLEGE OF ENGINEERING", 105, startY + 10, { align: "center" });
        doc.text("THIRUVANANTHAPURAM - 16", 105, startY + 16, { align: "center" });

        doc.setFontSize(11);
        doc.text("Ph: 0471- 2515689, e-mail Id warden@cet.ac.in", 105, startY + 22, { align: "center" });

        // Voucher details
        doc.line(20, startY + 25, 190, startY + 25);

        doc.setFontSize(10);
        const voucherNumber = `No. ${receiptOrVoucherNo || 'FR-' + new Date().getTime()}`;
        const dateStr = new Date().toLocaleDateString();
        doc.text(voucherNumber, 20, startY + 32);
        doc.text(`Date: ${dateStr}`, 150, startY + 32);

        // Voucher title
        doc.setFontSize(12);
        doc.setFont("Times", "bold");
        const voucherTitle = isRefund ? "ADVANCE AMOUNT REFUND VOUCHER" : "ADVANCE AMOUNT SETTLEMENT RECEIPT";
        doc.text(voucherTitle, 20, startY + 40);

        // Student details
        doc.setFontSize(10);
        doc.setFont("Times", "bold");
        doc.text("Inmate Details:", 20, startY + 46);
        doc.setFont("Times", "normal");

        const hostelAdmissionNo = `Hostel Admission No: ${inmateData?.hostel_admission_no || ''}`;
        const collegAdmissionNo = `College Admission No: ${inmateData?.admission_no || ''}`;
        const studentName = `Name: ${inmateData?.name || ''}`;
        const programme = `Programme: ${inmateData?.programme || ''}`;
        const department = `Department: ${inmateData?.department || ''}`;
        const vacatingDate = `Vacating Date: ${inmateData?.vacating_date ? new Date(inmateData.vacating_date).toLocaleDateString() : ''}`;

        // Display details in side-by-side format
        doc.text(hostelAdmissionNo, 20, startY + 52);
        doc.text(collegAdmissionNo, 110, startY + 52);
        doc.text(studentName, 20, startY + 58);
        doc.text(programme, 110, startY + 58);
        doc.text(department, 20, startY + 64);
        doc.text(vacatingDate, 110, startY + 64);

        // Settlement details table
        doc.line(20, startY + 70, 190, startY + 70);
        doc.setFont("Times", "bold");
        doc.text("Settlement Details", 25, startY + 76);
        doc.text("Amount", 165, startY + 76);
        doc.line(20, startY + 78, 190, startY + 78);

        // Settlement items
        doc.setFont("Times", "normal");
        let currentY = startY + 83;

        doc.text("Advance Amount Paid", 25, currentY);
        doc.text(`Rs.${advanceAmount}/-`, 165, currentY);
        currentY += 5;

        doc.text("Amount Used/Deducted", 25, currentY);
        doc.text(`Rs.${usedAmount}/-`, 165, currentY);
        currentY += 5;

        // Settlement amount
        doc.line(20, currentY + 2, 190, currentY + 2);
        doc.setFont("Times", "bold");

        if (isRefund) {
          doc.text("Amount to be Refunded", 25, currentY + 7);
          doc.text(`Rs.${Math.abs(balanceAmount)}/-`, 165, currentY + 7);
        } else if (balanceAmount < 0) {
          doc.text("Amount to be Collected", 25, currentY + 7);
          doc.text(`Rs.${Math.abs(balanceAmount)}/-`, 165, currentY + 7);
        } else {
          doc.text("No Amount Due", 25, currentY + 7);
          doc.text("Rs.0/-", 165, currentY + 7);
        }

        // Amount in words
        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        if (balanceAmount !== 0) {
          const amountInWords = converter.toWords(Math.abs(balanceAmount));
          doc.text(`(Rupees ${amountInWords} only)`, 25, currentY + 12);
        } else {
          doc.text("(No amount due)", 25, currentY + 12);
        }

        // Status and signatures
        doc.setFontSize(10);
        doc.setFont("Times", "bold");
        if (isRefund) {
          doc.text("Status: REFUND RECEIVED", 25, currentY + 20);
        } else if (balanceAmount < 0) {
          doc.text("Status: BALANCE PAID AND NO DUES", 25, currentY + 20);
        } else {
          doc.text("Status: SETTLEMENT COMPLETE", 25, currentY + 20);
        }

        // Signature section
        doc.setFont("Times", "normal");
        doc.text("Inmate Signature: ____________________", 25, currentY + 30);
        doc.text("Authorized Signatory", 150, currentY + 30);

        // Copy indicator
        doc.setFontSize(8);
        doc.text(type, 20, currentY + 35);

        // Important note
        doc.setFontSize(8);
        doc.setFont("Times", "italic");
        if (isRefund) {
          doc.text("Note: This voucher must be presented to collect the refund amount.", 25, currentY + 40);
        } else if (balanceAmount < 0) {
          doc.text("Note: Outstanding amount must be cleared before final relief.", 25, currentY + 40);
        }

      } catch (error) {
        console.error('Error in generateVoucherCopy:', error);
        throw error;
      }
    };

    // Generate first copy
    generateVoucherCopy(0, "OFFICE COPY");

    // Add dividing line
    doc.setLineDash([2, 2]);
    doc.line(10, 148, 200, 148);
    doc.setFontSize(8);
    doc.text("Cut Here", 95, 150);
    doc.setLineDash([]);

    // Generate second copy
    generateVoucherCopy(148, "STUDENT COPY");

    return doc;
  } catch (error) {
    console.error('Error in generateFullReliefVoucherPDF:', error);
    throw error;
  }
};

export const generateAndDownloadFullReliefVoucher = async (inmateData, receiptOrVoucherNo) => {
  try {

    if (!inmateData) {
      throw new Error('Inmate data is required');
    }
    if (!receiptOrVoucherNo) {
      throw new Error('receiptOrVoucherNo is required');
    }

    const doc = generateFullReliefVoucherPDF(inmateData, receiptOrVoucherNo);

    // Generate filename
    const filename = `full_relief_voucher_${inmateData.hostel_admission_no || 'unknown'}_${new Date().getTime()}.pdf`;

    doc.save(filename);
  } catch (error) {
    console.error('Error generating Full Relief Voucher PDF:', error);
    throw error;
  }
};